import { atom } from "jotai";

import { NewGuestRoundInput } from "../../../../../components/TransferOwnership/hooks/__generated__/useUpdateSingleSlotBookingMutation.graphql";
import { currentBookingAtom } from "../../../../stores";

export const updatedNewGuestRoundsAtom = atom<NewGuestRoundInput[] | null>(
  (get) => {
    const currentBooking = get(currentBookingAtom);
    if (!currentBooking) return null;
    const rounds = currentBooking.rounds;
    const newGuestRounds = rounds?.filter(
      (r) => r.player?.clientType === "newGuest"
    );
    const input: NewGuestRoundInput[] = newGuestRounds?.map((r) => ({
      index: r.index,
      id: r.serverId,
      playerId: r.player?.id || null,
      courseLayoutId: r.type === "Golf" ? r.courseLayout?.id : null,
      transportationTypeId: r.type === "Golf" ? r.transportationType?.id : null,
      name:
        r.player?.firstName || r.player?.lastName
          ? `${r.player.firstName ?? ""} ${r.player.lastName ?? ""}`.trim()
          : "",
    }));
    return input;
  }
);
